import { onErrorResetAndRery } from './middleware';
export default (persistKey) => {
    const loadState = () => {
        try {
            const serialState = localStorage.getItem(persistKey);
            if (serialState === null) {
                return undefined;
            }
            return JSON.parse(serialState);
        }
        catch (err) {
            return undefined;
        }
    };
    const saveState = (state) => {
        if (typeof window === 'undefined') {
            return;
        }
        try {
            const removeLoadingAndError = (obj) => {
                const keysToRemove = ['isLoading', 'error'];
                if (obj && typeof obj === 'object') {
                    keysToRemove.forEach(key => {
                        if (key in obj) {
                            delete obj[key];
                        }
                    });
                    Object.keys(obj).forEach(key => {
                        removeLoadingAndError(obj[key]);
                    });
                }
            };
            const cleanState = JSON.parse(JSON.stringify(state));
            removeLoadingAndError(cleanState);
            const serialState = JSON.stringify(cleanState);
            localStorage.setItem(persistKey, serialState);
        }
        catch (err) {
            console.error(err);
        }
    };
    const persistState = (store) => {
        saveState(store.getState());
        store.subscribe(() => {
            saveState(store.getState());
        });
        const resetState = (payload) => {
            localStorage.removeItem(persistKey);
            store.dispatch({
                type: 'RESET_STATE',
                payload
            });
        };
        return { resetState };
    };
    const persistMiddleware = [onErrorResetAndRery(persistKey)];
    return {
        loadState,
        saveState,
        persistState,
        persistMiddleware
    };
};
